export default {
  schema: {
    type: 'object',
    properties: {
      type: {
        type: 'string',
        title: 'Contract/Grant/Research Type',
        enum: ['642318', '642319', '642320'],
        enumNames: ['Contract', 'Grant', 'Sponsored Research'],
        maxLength: 20000
      },
      title: {
        type: 'string',
        title: 'Contract/Grant/Research Title',
        maxLength: 20000
      },
      sponorg: {
        type: 'string',
        title: 'Sponsoring Organization',
        maxLength: 20000
      },
      awardorg: {
        type: 'string',
        title: 'Awarding Organization Is',
        enum: ['642265', '642266', '642267', '642268', '642269', '642270'],
        enumNames: ['Your University', 'Local', 'State', 'Federal', 'Private', 'Other'],
        maxLength: 20000
      },
      status: {
        type: 'string',
        title: 'Current Status',
        enum: ['642378', '642379', '642380'],
        enumNames: ['Currently Under Review', 'Funded', 'Not Funded'],
        maxLength: 20000
      },
      amount: {
        type: 'number',
        title: 'Amount'
      },
      abstract: {
        type: 'string',
        title: 'Abstract',
        maxLength: 20
      },
      congrant_invest: {
        type: 'array',
        title: 'Investigators',
        uniqueItems: true,
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string',
              title: 'id'
            },
            faculty_name: {
              type: 'string',
              title: 'People at Your University',
              $ref: '#/definitions/users'
            },
            fname: {
              type: 'string',
              title: 'First Name',
              maxLength: 20000
            },
            mname: {
              type: 'string',
              title: 'Middle Name/Initial',
              maxLength: 20000
            },
            lname: {
              type: 'string',
              title: 'Last Name',
              maxLength: 20000
            },
            role: {
              type: 'string',
              title: 'Role',
              enum: ['642313', '642314', '642315', '642316'],
              enumNames: ['Principal', 'Co-Principal', 'Supporting', 'Other'],
              maxLength: 20000
            },
            student_level: {
              type: 'string',
              title: 'If a student, what is his/her level?',
              enum: ['642653', '642654'],
              enumNames: ['Undergraduate', 'Graduate'],
              maxLength: 20000
            }
          },
          required: [],
          dependencies: {},
          additionalProperties: false
        },
        minItems: 1
      },
      dtm_expsub: {
        type: 'string',
        title: 'Expected Month of Submission for Funding',
        $ref: '#/definitions/months-642419'
      },
      dtd_expsub: {
        type: 'integer',
        title: 'Expected Day of Submission for Funding',
        minimum: 1,
        maximum: 31
      },
      dty_expsub: {
        type: 'integer',
        title: 'Expected Year of Submission for Funding',
        minimum: 1900,
        maximum: 2100
      },
      dtm_sub: {
        type: 'string',
        title: 'Month Submitted for Funding',
        $ref: '#/definitions/months-642419'
      },
      dtd_sub: {
        type: 'integer',
        title: 'Day Submitted for Funding',
        minimum: 1,
        maximum: 31
      },
      dty_sub: {
        type: 'integer',
        title: 'Year Submitted for Funding',
        minimum: 1900,
        maximum: 2100
      },
      dtm_start: {
        type: 'string',
        title: 'Month',
        $ref: '#/definitions/months-642419'
      },
      dtd_start: {
        type: 'integer',
        title: 'Day',
        minimum: 1,
        maximum: 31
      },
      dty_start: {
        type: 'integer',
        title: 'Year',
        minimum: 1900,
        maximum: 2100
      },
      dtm_end: {
        type: 'string',
        title: 'Month',
        $ref: '#/definitions/months-642419'
      },
      dtd_end: {
        type: 'integer',
        title: 'Day',
        minimum: 1,
        maximum: 31
      },
      dty_end: {
        type: 'integer',
        title: 'Year',
        minimum: 1900,
        maximum: 2100
      }
    },
    required: [],
    dependencies: {
      dtm_expsub: ['dty_expsub'],
      dtd_expsub: ['dtm_expsub'],
      dtm_sub: ['dty_sub'],
      dtd_sub: ['dtm_sub'],
      dtm_start: ['dty_start'],
      dtd_start: ['dtm_start'],
      dtm_end: ['dty_end'],
      dtd_end: ['dtm_end']
    },
    additionalProperties: false,
    definitions: {
      users: {
        enum: ['2130795', '1929218', '2129670', '1743776', '1792775', '1813577', '1792757', '2029971', '1964032', '1387828', '2141683', '1792774', '2129661', '2106830', '1984156', '1792760', '2106834', '1792759', '2084460', '1831048', '1934273', '863601', '2086492', '2086497', '2086501', '2086502', '2130794', '1446743', '1778802', '1387138', '1792762', '533952', '1792763', '2128906', '2091267', '2112658', '1387832', '2106675', '1792761', '489389', '1929638', '1804474', '1792765', '1792773', '2122379', '1792766', '1751078', '1767868', '1867928', '2089019', '2139572', '624037', '2129680', '2097274', '1895008', '863600', '2106833', '2129660', '1964044', '2025074', '2106674', '867409', '1792764', '1792755', '2136321', '2137738', '2129662', '1388609', '2029677', '930333', '1387833', '1972662', '2140302', '1787873', '2009940', '1721120', '1792758', '1743961', '2106672', '1679931', '1679933', '1167539', '1760836', '859768', '1385130', '2106673', '1971881', '1792770', '1792756', '1964669', '2138373', '2106832', '2112659', '2136320', '2137888', '1792754', '1867927', '526155', '933422', '1791362', '1792768', '1915147', '1454782', '1792769', '1826302', '1383103', '1826303', '2104213', '1940130', '933417', '933418', '933419', '933420', '933421', '1894115', '1234917', '2091269', '2120356', '1792771', '2031409', '1887982', '1950524', '1792772'],
        enumNames: ['Administrator, Sahil (smehan.admin)', 'Alos, Liam (alosl)', 'Arya, Gaurav (garya)', 'Becker, Kevin f (kbecker)', 'Bentley, Miles (mbentley)', 'Bernsteen, Mallory (mbernsteen)', 'Blake, Camille (cbronte)', 'bob, smith (bsmith1)', 'Brody, Marcus (marcus.brody)', 'Brown, Henry (hbrown)', 'Cassidy, Pete (pcassidy)', 'Chambers, Felix H (fchambers)', 'Chawla, Sahil (schawla)', 'Chawla, Vikas (vchawla)', 'Client Raymonds, Jim (jrclient)', 'Daniels, Clive (cdaniels)', 'Dhankar, Vishal (vdhankar)', 'Dickinson, Allison (edickinson)', 'Doe, Jane (j.doe)', 'Doe, John (jdoe)', 'Draper, Betty H (bdraper)', 'Duck, Laurence (lduck)', 'Example01, COFC Candidate (COFCCandidate)', 'Example04, COFC Advisory Member 02 (COFCAdvisory2)', 'Example08, COFC Evaluation Committee 1 (COFCEvaluation1)', 'Example10, COFC Evaluation Committee 2 (COFCEvaluation2)', 'Faculty, Sahil (smehan)', 'Farmer, Nicole (i.nicole.farmer)', 'Flarity, Natalie (nflarity)', 'Flinstone, Nora (nflinstone)', 'Foster, Ewan (efoster)', 'Fredricks, Nicole E (nfredricks)', 'Frost, Rodger (rfrost)', 'Gary, Scott (sgary)', 'Gehring, Keith (keith.gehring)', 'Gokhale, Milind (mgokhale)', 'Goldstein, Monika E (monika.goldstein)', 'Golob, Michelle (mgolob)', 'Grant, Nicholas (ngrant)', 'Green, Janet (jgreen)', 'Harris, Joan (jharris)', 'Harrison, William H (william.h.harrison)', 'Holmes, Henry (hholmes)', 'Holt, Marvin (mholt)', 'Horton, Elizabeth (ehorton)', 'Hughes, Larry (lhughes)', 'Jackson, Cecil J (kfitch)', 'Jean, Stacy (stacy.jean)', 'Jones, Kurt (kjones)', 'Juan, Guerra L (jlguerra)', 'Kalmus, Katie (kkalmus)', 'Kapilo, Katherine (kkapilo)', 'Kaur, Mandeep (mkaur)', 'Kieffer, John (jkieffer)', 'Kincade, Reginald (reginald.kincade)', 'Klove, Kasi (kklove)', 'Kohli, Neha (nkohli)', 'Kumar, Tarun (tkumar)', 'Lemerond, Meghan E (mlemerond)', 'Lewis, Kevin (klewis)', 'Limon, Pete (plimon)', 'Login, Test (ltest)', 'Longfellow, Howard (hlongfellow)', 'Maartens, Edward (emaartens)', 'Mahajan, Abhinav (amahajan)', 'Mahajan, Amitabh (abhistyle03)', 'Mahajan, Anuj (anujmahajan)', 'Medalski, Tanya (tmedalski)', 'Megenity, Charlie (charlie.megenity)', 'Mendleson, Grant (gmendleson)', 'Miller, Thaddius G (tmiller)', 'Moreno, Adrian (amoreno)', 'Neubauer, Laura (bethany.neubauer)', 'Nolan, Andrew (andrew.wiech)', 'Perlberg, Cara S (Example_User1)', 'Perlberg, L (lperlberg)', 'Poe, Edgar A (eapoe)', 'Record IDs, Test (testid)', 'Reeves, Starr (sreeves)', 'Resource, Center (rc_test2)', 'Resource, Center 3 (rc_test3)', 'Review, Chair (rchair)', 'Richards, Naiobi (nrichards)', 'Richards, Naiobi (sdelmore)', 'Roberts, Ann (roberts)', 'Rodriguez, Amie (arodriguez)', 'ron, james (james.ron)', 'Rowe, Curtis (crowe)', 'Sampson, Richard (rsampson)', 'Sarnowski, Dave (david.sarnowski)', 'Sharma, Chahat (csharma)', 'Sharma, Kamal (ksharma)', 'Shelly, Charanjeev (cshelly)', 'Shukla, Archit (ashukla)', 'Shukla, Archit Admin (archit_shukla13)', 'Sinclair, Eliza (esinclair)', 'Slocum, Peter (pslocum)', 'Smith, Bob (bsmith)', 'Smith, John (test6)', 'Smith, Laurie (laurie)', 'Snider, Robin (rsnider)', 'Sterling, Roger (roger_sterling)', 'Support, Digital Measures (support)', 'Tanner, Wesley (wtanner)', 'test, test (sbecker)', 'Test, User (test)', 'test3, test3 (test123)', 'Thompson, Webster (webster)', 'Usage, Test (test12345)', 'User 1, Test (test1)', 'User 2, Test (test2)', 'User 3, Test (test3)', 'User 4, Test (test4)', 'User 5, Test (test5)', 'User, Admin (admin.user)', 'User, Test20 (dmtest20)', 'Voena, Alessandra`` (AVoena)', 'Waldman, John (jwaldman)', 'Warren, Vincent (vwarren)', 'Wells, Jerome (jwells)', 'Wiech, Andrew (awiech)', 'Williams, Leah (leah.williams)', 'Yates, Gilbert (gyates)']
      },
      'months-642419': {
        enum: ['642420', '642421', '642422', '642423', '642424', '642425', '642426', '642427', '642428', '642429', '642430', '642431'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    },
    title: 'Contracts, Grants and Sponsored Research',
    allOf: [{
      anyOf: [{
        required: ['dty_expsub']
      }, {
        required: ['dty_sub']
      }, {
        required: ['dty_start']
      }, {
        required: ['dty_end']
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_expsub: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_expsub: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_expsub: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_expsub: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_expsub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_expsub: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_expsub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_expsub: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_sub: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_sub: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_sub: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_sub: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_sub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_sub: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_sub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_sub: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_start: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_start: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_start: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_start: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_start: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_start: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_start: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_start: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_end: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_end: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_end: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_end: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_end: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_end: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_end: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_end: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      anyOf: [{
        properties: {
          congrant_invest: {
            contains: {
              properties: {
                faculty_name: {
                  const: '859768'
                }
              }
            }
          }
        }
      }]
    }]
  },
  uiSchema: {
    '643171': {
      'ui:title': {
        text: 'Expected Date of Submission for Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    '643174': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643176': {
      'ui:title': {
        text: 'Date Submitted for Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    '643179': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643182': {
      'ui:title': {
        text: 'Start Date of Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    '643185': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643187': {
      'ui:title': {
        text: 'End Date of Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    '643190': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    'dm:layout': [{
      id: 'type',
      type: 'field'
    }, {
      id: 'title',
      type: 'field'
    }, {
      id: 'sponorg',
      type: 'field'
    }, {
      id: 'awardorg',
      type: 'field'
    }, {
      id: 'status',
      type: 'field'
    }, {
      id: 'amount',
      type: 'field'
    }, {
      id: 'abstract',
      type: 'field'
    }, {
      id: 'congrant_invest',
      type: 'array'
    }, {
      id: '643171',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_expsub',
        type: 'field'
      }, {
        id: 'dtd_expsub',
        type: 'field'
      }, {
        id: '643174',
        type: 'text'
      }, {
        id: 'dty_expsub',
        type: 'field'
      }]
    }, {
      id: '643176',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_sub',
        type: 'field'
      }, {
        id: 'dtd_sub',
        type: 'field'
      }, {
        id: '643179',
        type: 'text'
      }, {
        id: 'dty_sub',
        type: 'field'
      }]
    }, {
      id: '643182',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_start',
        type: 'field'
      }, {
        id: 'dtd_start',
        type: 'field'
      }, {
        id: '643185',
        type: 'text'
      }, {
        id: 'dty_start',
        type: 'field'
      }]
    }, {
      id: '643187',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_end',
        type: 'field'
      }, {
        id: 'dtd_end',
        type: 'field'
      }, {
        id: '643190',
        type: 'text'
      }, {
        id: 'dty_end',
        type: 'field'
      }]
    }],
    type: {
      'ui:title': {
        text: 'Contract/Grant/Research Type',
        escape: true
      },
      'ui:widget': 'select'
    },
    title: {
      'ui:title': {
        text: 'Contract/Grant/Research Title',
        escape: true
      },
      'ui:widget': 'text'
    },
    sponorg: {
      'ui:title': {
        text: 'Sponsoring Organization',
        escape: true
      },
      'ui:widget': 'text'
    },
    awardorg: {
      'ui:title': {
        text: 'Awarding Organization Is',
        escape: true
      },
      'ui:widget': 'select'
    },
    status: {
      'ui:title': {
        text: 'Current Status',
        escape: true
      },
      'ui:widget': 'select'
    },
    amount: {
      'ui:title': {
        text: 'Amount',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    abstract: {
      'ui:title': {
        text: 'Abstract',
        escape: true
      },
      'ui:widget': 'richtext'
    },
    congrant_invest: {
      items: {
        '643161': {
          'ui:widget': 'text'
        },
        'dm:layout': [{
          id: 'faculty_name',
          type: 'field'
        }, {
          id: 'fname',
          type: 'field'
        }, {
          id: 'mname',
          type: 'field'
        }, {
          id: 'lname',
          type: 'field'
        }, {
          id: 'role',
          type: 'field'
        }, {
          id: 'student_level',
          type: 'field'
        }],
        faculty_name: {
          'ui:title': {
            text: 'People at Your University',
            escape: true
          },
          'ui:widget': 'select'
        },
        fname: {
          'ui:title': {
            text: 'First Name',
            escape: true
          },
          'ui:widget': 'text'
        },
        mname: {
          'ui:title': {
            text: 'Middle Name/Initial',
            escape: true
          },
          'ui:widget': 'text'
        },
        lname: {
          'ui:title': {
            text: 'Last Name',
            escape: true
          },
          'ui:widget': 'text'
        },
        role: {
          'ui:title': {
            text: 'Role',
            escape: true
          },
          'ui:widget': 'select'
        },
        student_level: {
          'ui:title': {
            text: 'If a student, what is his/her level?',
            escape: true
          },
          'ui:widget': 'select'
        }
      },
      'ui:title': {
        text: 'Investigators',
        escape: false
      },
      'ui:description': {
        text: 'Please select a person from the drop-down list and/or enter their name in the input fields.',
        escape: false
      },
      'ui:options': {
        itemName: 'Investigator'
      }
    },
    dtm_expsub: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_expsub: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_expsub: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    dtm_sub: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_sub: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_sub: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    dtm_start: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_start: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_start: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    dtm_end: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_end: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_end: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    }
  },
  formData: {
    type: '642320',
    title: 'Test 1',
    awardorg: '642267',
    status: '642379',
    amount: 5000,
    congrant_invest: [{
      id: '103859251212',
      faculty_name: '859768',
      role: '642314'
    }, {
      id: '103859251211',
      faculty_name: '2129670',
      role: '642315',
      student_level: '642654'
    }],
    dtm_expsub: '642421',
    dtd_expsub: 28,
    dty_expsub: 2011
  }
};